import React from 'react';
import Map from './Map/Map';
import MainControl from './Controls';
import SettingsPanel from './Controls/settings-panel';
// Mutil Language
import { LocalizeProvider } from 'react-localize-redux';
// Self-Defined Functions
import { mapFlyToGeoJsonObject_byID, defaultMarkerIcon } from 'utils/mapUtils'; 

class App extends React.Component {
  state = {
    map: null,
    activeLang: 'en',
    geoJsonId: null,
    srcCoord: null,
  }; 

  componentDidMount() {
    
    const urlParams = new URLSearchParams(window.location.search);    
    const lang = urlParams.get('lang');
    const id = urlParams.get('geoJsonId');
    const coord = urlParams.get('srcCoord');

    if (lang) {
      this.setState({ activeLang: lang });
    }

    if (id) {
      this.setState({ geoJsonId: id });
    }
    
    if (coord) {
      this.setState({ srcCoord: coord });
    }
  }

  componentDidUpdate() {
    const { map, activeLang, geoJsonId, srcCoord } = this.state;

    // Fly to the location if only geoJsonId is provided
    if (map && activeLang) {
      if (geoJsonId && !srcCoord) {        
        mapFlyToGeoJsonObject_byID(map, geoJsonId, activeLang);        
      }         
    }
  }

  setMap = (map) => {
    this.setState({ map });
  };

  setActiveLang = (lang) => {
    this.setState({ activeLang: lang });
  };

  setGeoJsonId = (id) => {
    this.setState({ geoJsonId: id });
  };

  setSrcCoord = (coord) => {
    this.setState({ srcCoord: coord });
  };


  render() {    
    return (
      <LocalizeProvider>
        <div>
          <Map 
            setMap={this.setMap} 
            map={this.state.map} 
            activeLang={this.state.activeLang} 
            geoJsonId={this.state.geoJsonId} 
            srcCoord={this.state.srcCoord} 
          />
          <MainControl 
            map={this.state.map} 
            activeLang={this.state.activeLang} 
            setActiveLang={this.setActiveLang} 
            geoJsonId={this.state.geoJsonId} 
            srcCoord={this.state.srcCoord} 
          />
          <SettingsPanel />
        </div>
      </LocalizeProvider>
    );
  }
}

export default App;